import React, { useState, useEffect } from "react";
import { reviews } from "../mock";
import Stars from "./Stars";
import { X } from "lucide-react";

// Positive reviews only (5 stars) for the rotating pop-up.
const positive = reviews.filter((r) => r.rating === 5);

export default function ReviewPopup() {
  const [i, setI] = useState(0);
  const [show, setShow] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (closed || positive.length === 0) return;
    const first = setTimeout(() => setShow(true), 4000);
    const cycle = setInterval(() => {
      setShow(false);
      setTimeout(() => {
        setI((p) => (p + 1) % positive.length);
        setShow(true);
      }, 500);
    }, 7000);
    return () => {
      clearTimeout(first);
      clearInterval(cycle);
    };
  }, [closed]);

  if (closed || positive.length === 0) return null;
  const r = positive[i];

  return (
    <div
      className={`fixed bottom-4 left-4 z-[60] w-[300px] max-w-[calc(100vw-2rem)] transition-all duration-500 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <div className="relative rounded-2xl border border-navy/10 bg-white p-4 shadow-2xl">
        <button
          onClick={() => setClosed(true)}
          className="absolute right-2 top-2 text-navy/30 hover:text-navy"
          aria-label="Close"
        >
          <X size={15} />
        </button>
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy text-sm font-heading font-bold text-white">
            {r.name.charAt(0)}
          </div>
          <div className="min-w-0">
            <p className="truncate text-sm font-bold text-navy">{r.name}</p>
            <div className="flex items-center gap-1.5">
              <Stars value={5} size={12} />
              <span className="text-[10px] text-navy/40">Verified · Google</span>
            </div>
          </div>
        </div>
        <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-navy/70">&ldquo;{r.text}&rdquo;</p>
      </div>
    </div>
  );
}
